/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_MottoInputs */

const en_footer_motto = /** @type {(inputs: Footer_MottoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The collection is born in the atelier, prepared backstage, bought from the front row.`)
};

/**
* | output |
* | --- |
* | "The collection is born in the atelier, prepared backstage, bought from the front row." |
*
* @param {Footer_MottoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_motto = /** @type {((inputs?: Footer_MottoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_MottoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_motto(inputs)
});